





























import { Component, Prop, Vue } from "vue-property-decorator";
import { DeleteWhooingEntries } from "../api/DeleteWhooingEntries";
import { EntriesInputHelper } from "../helpers/EntriesInputHelper";
import { IMergeSelected } from "../models/IMergeSelected";
import { WhooingDate } from "../utils/WhooingDate";

@Component
export default class MergeEntriesModal extends Vue {
  /** 병합선택 항목 */
  @Prop({ type: Object, required: true })
  public mergeSelected!: IMergeSelected;

  /** 병합될 거래내역 */
  @Prop({ type: Array, required: true })
  public entryIds!: number[];

  /** 섹션Id */
  @Prop({ type: String, required: true })
  public sId!: string;

  /** 머지 진행중 */
  public isMerging: boolean = false;

  public errorMessage: string = "";

  private async merge() {
    this.isMerging = true;
    const date = WhooingDate.ParseNumber(Number(this.mergeSelected.date));
    const input = { ...this.mergeSelected, sId: this.sId, date };
    try {
      // 거래 추가
      await EntriesInputHelper.PushEntryAsync(input);
      // 거래 삭제
      await DeleteWhooingEntries(this.entryIds);
      this.$emit("merged");
      this.$emit("close");
    } catch (err) {
      this.isMerging = false;
      this.errorMessage = "병합에 실패했습니다.";
    }
  }
}
